export default "__VITE_ASSET__DMNQw7y8__"